<div class="modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-dialog" (click)="onModalClick($event)" *ngIf="bonus">
    <div class="modal-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="fa-solid fa-gift"></i>
        </div>
        <h2 class="modal-title">{{ 'bonusPages.bonusDetail' | translate }}</h2>
      </div>
      <button class="close-button" (click)="onClose()" [attr.aria-label]="'common.close' | translate">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- Status Badge -->
      <div class="status-row">
        <span class="status-badge" [ngClass]="getStatusClass(bonus.status)">
          <i class="fa-solid" [ngClass]="getStatusIcon(bonus.status)"></i>
          {{ 'statusLabels.' + bonus.status | translate }}
        </span>
      </div>

      <!-- Bonus Amount (Highlight) -->
      <div class="amount-section">
        <div class="amount-label">{{ 'bonusPages.amount' | translate }}</div>
        <div class="amount-value">
          {{ bonus.bonusAmount || bonus.amount | number:'1.0-0' }} {{ 'common.currency' | translate }}
        </div>
      </div>

      <!-- Details Grid -->
      <div class="details-grid">
        <!-- Policy Number -->
        <div class="detail-item">
          <div class="detail-icon">
            <i class="fa-solid fa-file-contract"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.policyNo' | translate }}</span>
            <span class="detail-value">{{ bonus.policyNo || bonus.policyNumber }}</span>
          </div>
        </div>

        <!-- Product Name -->
        <div class="detail-item" *ngIf="bonus.productName">
          <div class="detail-icon">
            <i class="fa-solid fa-box"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.productName' | translate }}</span>
            <span class="detail-value">{{ bonus.productName }}</span>
          </div>
        </div>

        <!-- Bonus Type -->
        <div class="detail-item">
          <div class="detail-icon">
            <i class="fa-solid fa-tag"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.bonusType' | translate }}</span>
            <span class="detail-value">{{ 'bonusPages.' + bonus.bonusType | translate }}</span>
          </div>
        </div>

        <!-- Bonus Date -->
        <div class="detail-item">
          <div class="detail-icon">
            <i class="fa-solid fa-calendar-days"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.bonusDate' | translate }}</span>
            <span class="detail-value">{{ bonus.bonusDate | laoDate:'full' }}</span>
          </div>
        </div>

        <!-- Payment Date -->
        <div class="detail-item" *ngIf="bonus.paymentDate">
          <div class="detail-icon">
            <i class="fa-solid fa-calendar-check"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.paymentDate' | translate }}</span>
            <span class="detail-value">{{ bonus.paymentDate | laoDate:'full' }}</span>
          </div>
        </div>

        <!-- Policy Year -->
        <div class="detail-item" *ngIf="bonus.policyYear">
          <div class="detail-icon">
            <i class="fa-solid fa-calendar"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.policyYear' | translate }}</span>
            <span class="detail-value">{{ bonus.policyYear }}</span>
          </div>
        </div>

        <!-- Bonus Year -->
        <div class="detail-item" *ngIf="bonus.bonusYear">
          <div class="detail-icon">
            <i class="fa-solid fa-calendar-plus"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.bonusYear' | translate }}</span>
            <span class="detail-value">{{ bonus.bonusYear }}</span>
          </div>
        </div>

        <!-- Transaction ID -->
        <div class="detail-item" *ngIf="bonus.transactionId">
          <div class="detail-icon">
            <i class="fa-solid fa-hashtag"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">{{ 'bonusPages.transactionId' | translate }}</span>
            <span class="detail-value">{{ bonus.transactionId }}</span>
          </div>
        </div>

        <!-- Bonus ID -->
        <div class="detail-item" *ngIf="bonus.bonusId || bonus.id">
          <div class="detail-icon">
            <i class="fa-solid fa-fingerprint"></i>
          </div>
          <div class="detail-content">
            <span class="detail-label">ID</span>
            <span class="detail-value">{{ bonus.bonusId || bonus.id }}</span>
          </div>
        </div>
      </div>

      <!-- Description Section -->
      <div class="description-section" *ngIf="bonus.description || bonus.bonusDescription">
        <div class="section-header">
          <i class="fa-solid fa-file-lines"></i>
          <span>{{ 'bonusPages.description' | translate }}</span>
        </div>
        <p class="description-text">{{ bonus.description || bonus.bonusDescription }}</p>
      </div>

      <!-- Remarks Section -->
      <div class="description-section" *ngIf="bonus.remarks">
        <div class="section-header">
          <i class="fa-solid fa-comment"></i>
          <span>{{ 'bonusPages.remarks' | translate }}</span>
        </div>
        <p class="description-text">{{ bonus.remarks }}</p>
      </div>

      <!-- Withdrawal Info (if available) -->
      <div class="withdrawal-section" *ngIf="bonus.withdrawDate || bonus.withdrawAmount">
        <div class="section-header">
          <i class="fa-solid fa-hand-holding-dollar"></i>
          <span>{{ 'bonusPages.withdrawalRequest' | translate }}</span>
        </div>
        <div class="withdrawal-grid">
          <div class="withdrawal-item" *ngIf="bonus.withdrawDate">
            <span class="withdrawal-label">{{ 'bonusPages.withdrawDate' | translate }}</span>
            <span class="withdrawal-value">{{ bonus.withdrawDate | laoDate:'full' }}</span>
          </div>
          <div class="withdrawal-item" *ngIf="bonus.withdrawAmount">
            <span class="withdrawal-label">{{ 'bonusPages.withdrawnAmount' | translate }}</span>
            <span class="withdrawal-value">{{ bonus.withdrawAmount | number:'1.0-0' }} {{ 'common.currency' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="close-footer-button" (click)="onClose()">
        {{ 'common.close' | translate }}
      </button>
    </div>
  </div>
</div>
